import { useEffect, useRef, useCallback } from "react";
import ChatViewer from "../../../../components/ChatViewer";
import { useChat } from "../../../../hooks/useChat";
import { useRestoUsers } from "../../../../hooks/useRestoUsers";
import { useProfile } from "../../../../hooks/useTypeProfile";

export const ChatMobileTab = () => {
    const { chatMessages, sendAll, sendSingleMessage, refreshBeforeSend, markReadMessages } = useChat();
    const { hostResto, getAllRestoHost} = useRestoUsers()
    const { getTypeRole } = useProfile();
    const chatRef = useRef(null);
    const type = getTypeRole() || "host";

    useEffect(() => {
        refreshBeforeSend();
        getAllRestoHost();
    }, [])

    const handleSend = useCallback((payload) => {
        const users = (payload?.mentions || [])?.map(e => e.value);
        const message = payload?.message || "";
        const isAll = users.includes("ALL_USERS");
        if (isAll) {
            sendAll(message, []);
        } else {
            sendSingleMessage(message, users)
        }
    }, [sendAll, sendSingleMessage]);

    const handleMarkRead = useCallback(() => {
        markReadMessages();
    }, [markReadMessages]);

    return <>
        <ChatViewer
            ref={chatRef}
            messages={chatMessages}
            onSend={handleSend}
            users={(hostResto || [])?.map(e => ({ label: e.name, value: e._id }))}
            heightTab={window.innerHeight}
            onMark={handleMarkRead}
            type={type}
        />
    </>
}
